export enum STORAGE_KEY {
  REOPEN_FEEDBACK = 'omilia_reopen_feedback',
  VIEW_FEEDBACK = 'omilia_view_feedback',
  PREVIOUS_DIALOG_ID = 'omilia_previous_dialog_id',
  SESSION_ID = 'omilia_session_id',
  CLOSE_FEEDBACK = 'omilia_close_feedback',
  WELCOME_FORM = 'omilia_welcome_form',
  TRANSFERRED = 'omilia_transferred',
  TRANSFER_ID = 'omilia_transfer_id',
  TAB_SESSION_ID = 'omilia_tab_session_id',
  MINIMIZED_CHAT = 'omilia_minimized_chat',
  UNREAD_MESSAGES = 'omilia_unread_messages',
  LAST_SEEN_MESSAGE_ID = 'omilia_last_seen_message_id',
  CURRENT_CHAT_STATUS = 'omilia_current_chat_status',
  MUTE_SOUND = 'omilia_mute_sound',
  CHATS_STATUS = 'omilia_chats_status',
}
